module.exports = __webpack_public_path__ + "img/styria-fides.5d0633fe.svg";